import styled from 'styled-components';
import { Columns } from '@components/Columns';
import { Box } from '@components/Box';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';

export const SectionWrapper = styled(Box)`
  overflow-x: hidden;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  background-color: #064039;
`;

export const StyledBox = styled(Box)<{ isVisible: boolean }>`
  background-image: url(${({ isVisible }) => (isVisible ? cloudAssetUrl('guest-list/messaging-invitations/bg-art.png') : '')});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  ${themeMediaQuery('below_sm')} {
    background-size: cover;
    transform: scale(1.2);
    padding-top: 5rem;
  }
`;

export const ColumnsWrapper = styled(Columns)`
  justify-content: space-between;
  ${themeMediaQuery('md')} {
    max-width: 57.5rem;
  }
`;

export const ColumnsInnerWrapper = styled(Columns.Column)`
  ${themeMediaQuery('below_sm')} {
    margin-bottom: ${themeSpace(8)};
  }
  ${themeMediaQuery('lg')} {
    width: auto;
  }
  ${themeMediaQuery('md')} {
    width: auto;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
  height: 100%;
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      width: 200px;
    }
  }
`;

export const StyledBlogTextPairing = styled(TextPairing)`
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      text-align: center;
    }
  }
  .text-pairing-body {
    max-width: 237px;
    ${themeMediaQuery('below_sm')} {
      text-align: center;
      max-width: 232px;
      margin: auto;
    }
  }
`;

export const AnimationWrapper = styled.div``;
